export const SET_LOCATIONS_IN_META_POPUP = 'SET_LOCATIONS_IN_META_POPUP';
export const ADD_LOCATION_IN_META_POPUP = 'ADD_LOCATION_IN_META_POPUP';
export const REMOVE_LOCATION_IN_META_POPUP = 'REMOVE_LOCATION_IN_META_POPUP';
export const UPDATE_SECTION_TITLE_IN_THE_META_POPUP =
    'UPDATE_SECTION_TITLE_IN_THE_META_POPUP';
export const UPDATE_SECTION_META_TITLE_IN_THE_META_POPUP =
    'UPDATE_SECTION_META_TITLE_IN_THE_META_POPUP';
export const UPDATE_SECTION_SUBHEADING_IN_THE_META_POPUP =
    'UPDATE_SECTION_SUBHEADING_IN_THE_META_POPUP';
export const UPDATE_SECTION_OLD_URL_IN_THE_META_POPUP =
    'UPDATE_SECTION_OLD_URL_IN_THE_META_POPUP';
export const UPDATE_HERO_VIDEO_URL_IN_THE_META_POPUP =
    'UPDATE_HERO_VIDEO_URL_IN_THE_META_POPUP';
export const UPDATE_SECTION_BREADCRUMB_TITLE_IN_THE_META_POPUP =
    'UPDATE_SECTION_BREADCRUMB_TITLE_IN_THE_META_POPUP';
export const UPDATE_SECTION_MENU_TITLE_IN_THE_META_POPUP =
    'UPDATE_SECTION_MENU_TITLE_IN_THE_META_POPUP';
export const UPDATE_SECTION_META_DESCRIPTION_IN_THE_META_POPUP =
    'UPDATE_SECTION_META_DESCRIPTION_IN_THE_META_POPUP';
export const UPDATE_SECTION_LANDING_PRODUCTS_IN_THE_META_POPUP =
    'UPDATE_SECTION_LANDING_PRODUCTS_IN_THE_META_POPUP';
export const UPDATE_SNIPPET_TEXT_IN_THE_META_EDIT_POPUP =
    'UPDATE_SNIPPET_TEXT_IN_THE_META_EDIT_POPUP';
export const UPDATE_SNIPPET_SORT_ORDER_FIELD_IN_THE_META_EDIT_POPUP =
    'UPDATE_SNIPPET_SORT_ORDER_FIELD_IN_THE_META_EDIT_POPUP';
export const UPDATE_SNIPPET_ATTRIBUTE_FIELD_IN_THE_META_EDIT_POPUP =
    'UPDATE_SNIPPET_ATTRIBUTE_FIELD_IN_THE_META_EDIT_POPUP';
export const UPDATE_IS_TRAVEL_PRODUCT_FIELD_IN_THE_META_EDIT_POPUP =
    'UPDATE_IS_TRAVEL_PRODUCT_IN_THE_META_EDIT_POPUP';
export const ADD_HERO_IMAGE_IN_THE_META_EDIT_POPUP =
    'ADD_HERO_IMAGE_IN_THE_META_EDIT_POPUP';
export const DELETE_HERO_IMAGE_FIELD_IN_THE_META_EDIT_POPUP =
    'DELETE_HERO_IMAGE_FIELD_IN_THE_META_EDIT_POPUP';
export const UPDATE_HERO_CROPPED_IMAGE_IN_THE_EDIT_POPUP =
    'UPDATE_HERO_CROPPED_IMAGE_IN_THE_EDIT_POPUP';
export const UPDATE_HERO_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP =
    'UPDATE_HERO_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP';
export const UPDATE_REVIEW_CROPPED_IMAGE_IN_THE_EDIT_POPUP =
    'UPDATE_REVIEW_CROPPED_IMAGE_IN_THE_EDIT_POPUP';
export const UPDATE_REVIEW_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP =
    'UPDATE_REVIEW_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP';
export const UPDATE_HERO_IMAGE_META_IN_THE_EDIT_POPUP =
    'UPDATE_HERO_IMAGE_META_IN_THE_EDIT_POPUP';
export const UPDATE_REVIEW_IMAGE_META_IN_THE_EDIT_POPUP =
    'UPDATE_REVIEW_IMAGE_META_IN_THE_EDIT_POPUP';
export const OPEN_EDIT_META_SECTION_POPUP_POPUP =
    'OPEN_EDIT_META_SECTION_POPUP_POPUP';

export const FETCHED_SNIPPET_ATTRIBUTE_OPTIONS =
    'FETCHED_SNIPPET_ATTRIBUTE_OPTIONS';

/** reviews **/
export const UPDATE_SECTION_REVIEW_FULL_NAME_IN_THE_META_POPUP =
    'UPDATE_SECTION_REVIEW_FULL_NAME_IN_THE_META_POPUP';
export const UPDATE_SECTION_REVIEW_ABBREVIATED_NAME_IN_THE_META_POPUP =
    'UPDATE_SECTION_REVIEW_ABBREVIATED_NAME_IN_THE_META_POPUP';
export const UPDATE_SECTION_REVIEW_QUOTE_IN_THE_META_POPUP =
    'UPDATE_SECTION_REVIEW_QUOTE_IN_THE_META_POPUP';
export const UPDATE_SECTION_REVIEW_LANGUAGE_IN_THE_META_POPUP =
    'UPDATE_SECTION_REVIEW_LANGUAGE_IN_THE_META_POPUP';
export const UPDATE_SECTION_REVIEW_AGE_GROUP_IN_THE_META_POPUP =
    'UPDATE_SECTION_REVIEW_AGE_GROUP_IN_THE_META_POPUP';
export const UPDATE_SECTION_REVIEW_PRODUCTS_IN_THE_META_POPUP =
    'UPDATE_SECTION_REVIEW_PRODUCTS_IN_THE_META_POPUP';
export const FETCHED_PRODUCTS = 'FETCHED_PRODUCTS';
export const DELETE_REVIEW_IMAGE_FIELD_IN_THE_META_EDIT_POPUP =
    'DELETE_REVIEW_IMAGE_FIELD_IN_THE_META_EDIT_POPUP';
export const ADD_REVIEW_IMAGE_IN_THE_META_EDIT_POPUP =
    'ADD_REVIEW_IMAGE_IN_THE_META_EDIT_POPUP';

/** teams **/
export const UPDATE_SECTION_TEAM_IN_THE_META_POPUP =
    'UPDATE_SECTION_TEAM_IN_THE_META_POPUP';

/** blog */
export const UPDATE_SECTION_BLOG_AUTHOR_IN_THE_META_POPUP =
    'UPDATE_SECTION_BLOG_AUTHOR_IN_THE_META_POPUP';
export const UPDATE_SECTION_BLOG_DATE_IN_THE_META_POPUP =
    'UPDATE_SECTION_BLOG_DATE_IN_THE_META_POPUP';

/** fact box - project overview **/
export const FETCHED_OVERVIEW_DATES = 'FETCHED_OVERVIEW_DATES';
export const FETCHED_OVERVIEW_ACCOMMODATIONS =
    'FETCHED_OVERVIEW_ACCOMMODATIONS';
export const FETCHED_OVERVIEW_REQUIREMENTS = 'FETCHED_OVERVIEW_REQUIREMENTS';
export const UPDATE_OVERVIEW_DATES_IN_THE_META_EDIT_POPUP =
    'UPDATE_OVERVIEW_DATES_IN_THE_META_EDIT_POPUP';
export const UPDATE_OVERVIEW_REQUIREMENTS_IN_THE_META_EDIT_POPUP =
    'UPDATE_OVERVIEW_REQUIREMENTS_IN_THE_META_EDIT_POPUP';
export const UPDATE_OVERVIEW_ACCOMMODATION_IN_THE_META_EDIT_POPUP =
    'UPDATE_OVERVIEW_ACCOMMODATION_IN_THE_META_EDIT_POPUP';
export const UPDATE_OVERVIEW_ADDITIONAL_REQUIREMENTS_IN_THE_META_EDIT_POPUP =
    'UPDATE_OVERVIEW_ADDITIONAL_REQUIREMENTS_IN_THE_META_EDIT_POPUP';



// WEBPACK FOOTER //
// ./src/containers/builder/meta/types.js